import { FC } from 'react';

import { Button, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';

import { FormWrapper } from 'shared/ui/form-wrapper';
import { Input } from 'shared/ui/input';
import { ModalTemplate } from 'shared/ui/modal-template';
import { hasFormValuesChanged } from 'shared/utils';

interface IProps {
  isOpen: boolean;
  onSubmit: (data: any) => Promise<void>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MatchTransaction: FC<IProps> = ({ setIsOpen, isOpen, onSubmit }) => {
  const methods = useForm({ mode: 'onBlur' });
  const {
    reset,
    formState: { isDirty, isValid }
  } = methods;
  const isConfirmationNeeded = hasFormValuesChanged(methods.watch(), {});

  return (
    <ModalTemplate
      isConfirmationNeeded={isConfirmationNeeded}
      close={() => {
        setIsOpen(false);
      }}
      isOpen={isOpen}
      titleText={'Match transaction'}
      reset={reset}>
      <FormWrapper onSubmit={onSubmit} methods={methods}>
        <Stack direction='column' alignItems='stretch' gap='30px' flexWrap='nowrap'>
          <Input
            name='transaction_id'
            label='Enter transaction ID*'
            placeholder='Enter transaction ID'
            rules={{ required: 'Please, enter transaction ID' }}
          />
        </Stack>
        <Button
          type='submit'
          fullWidth
          disabled={!isConfirmationNeeded || !isValid}
          variant='contained'
          sx={{ mt: 15, borderRadius: 50, textTransform: 'none', height: 40 }}
          onSubmit={onSubmit}>
          Match
        </Button>
      </FormWrapper>
    </ModalTemplate>
  );
};
